import React, { useState } from 'react';
import { ArrowIcon, Button } from 'fronton-react';
import { AdvantagesCardsData } from 'data';
import { GAClickButton } from 'utils/analytics/analytics-events';
import { AdvantagesCard } from '../advantages-card';

import { ButtonStyles, CardsWrapper, ShadowBlock } from './styles';

export const AdvantagesCards = () => {
	const [isOpen, setIsOpen] = useState(false);
	const btnOnClickHandler = () => {
		GAClickButton({
			elementBlock: 'servicePage',
			elementName: !isOpen ? 'open-detailed' : 'close-detailed',
			elementText: 'Надежный и удобный сервис Лемана ПРО',
		});
		setIsOpen(!isOpen);
	};

	return (
		<>
			<CardsWrapper isOpen={isOpen}>
				{AdvantagesCardsData.map((data, index) => (
					<AdvantagesCard key={`advantages/card-${index}`} data={data} />
				))}
			</CardsWrapper>
			<ShadowBlock isOpen={isOpen}>
				<Button
					kind="regular"
					size="m"
					variant="secondary"
					rounded
					onClick={btnOnClickHandler}
					aria-label="icon"
					iconOnly
					className={ButtonStyles}
				>
					<ArrowIcon direction={isOpen ? 'top' : 'bottom'} />
				</Button>
			</ShadowBlock>
		</>
	);
};
